export const TRANSPORT_CONSIGNMENT_PERM = {
  menu: 'module:transport_consignment:transport_consignment',
  tabBasic: 'tab:transport_consignment:basic',
  tabProducts: 'tab:transport_consignment:products',
  tabTracking: 'tab:transport_consignment:tracking',
  tabCost: 'tab:transport_consignment:cost',
  tabBilling: 'tab:transport_consignment:billing',
  tabFiles: 'tab:transport_consignment:files',
  tabBizStatus: 'tab:transport_consignment:biz_status',
  costReceivable: 'module:transport_consignment_cost:receivable',
  costPayable: 'module:transport_consignment_cost:payable',
} as const

export type TransportConsignmentPermKey = keyof typeof TRANSPORT_CONSIGNMENT_PERM

export const TAB_PERMISSION_MAP: Record<string, string> = {
  basic: TRANSPORT_CONSIGNMENT_PERM.tabBasic,
  products: TRANSPORT_CONSIGNMENT_PERM.tabProducts,
  tracking: TRANSPORT_CONSIGNMENT_PERM.tabTracking,
  cost: TRANSPORT_CONSIGNMENT_PERM.tabCost,
  billing: TRANSPORT_CONSIGNMENT_PERM.tabBilling,
  files: TRANSPORT_CONSIGNMENT_PERM.tabFiles,
  bizStatus: TRANSPORT_CONSIGNMENT_PERM.tabBizStatus,
}
